/**
 * The Day timeline card's head: title + date, the dry-run badge, the link
 * to the ACTUAL drafts, Refresh. The totals line is gone (23/10/2026, client
 * QA: "Remove/Hide this text we have the same underneath" — the tiles).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ArrowUpRight, CalendarRange, RefreshCw } from 'lucide-react';

import { Badge, HintDot } from '@/components/ui';

import type { DayPlanPreview, DropGenPlanDetail } from '../../../drop-generator.types';
import { SectionAction } from '../section/SectionAction';

interface Props {
  plan: DropGenPlanDetail;
  preview: DayPlanPreview | undefined;
  loading: boolean;
  onRetry: () => void;
}

const ddmm = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export const TimelineHeader: FC<Props> = ({ plan, preview, loading, onRetry }) => (
  <div className="flex flex-wrap items-center gap-3 border-b border-border/60 px-5 py-4">
    <h2 className="flex items-center gap-2 text-sm font-semibold">
      <CalendarRange className="h-4 w-4 text-muted-foreground" />
      Day timeline{preview ? ` — ${ddmm(preview.runDate)}` : ''}
      <Badge tone="info">dry run</Badge>
      <HintDot label="What the planner lays out today, computed live from your config. Nothing is written here — Generate creates the drafts; a person sends them, or auto-send does where it is on." />
    </h2>
    <span className="grow" />
    <a
      href={
        preview
          ? `/smswiser/${plan.countryKey}?view=prepared&date=${preview.runDate}`
          : `/smswiser/${plan.countryKey}?view=prepared`
      }
      className="inline-flex h-7 items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-xs font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      title="The timeline is the blueprint — this opens the day's ACTUAL drafts"
    >
      Open today's drafts
      <ArrowUpRight className="h-3.5 w-3.5" aria-hidden />
    </a>
    <SectionAction icon={RefreshCw} onClick={onRetry} disabled={loading}>
      Refresh
    </SectionAction>
  </div>
);
